var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mt-4"
  }, [_c('b-modal', {
    attrs: {
      "id": "updatePaymentModal",
      "title": "Wijzig betaling",
      "size": "md",
      "centered": "",
      "dialog-class": "shadow-none"
    },
    on: {
      "ok": _vm.updatePayment
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function (_ref) {
        var cancel = _ref.cancel,
          ok = _ref.ok;
        return [_c('b-btn', {
          attrs: {
            "variant": "secondary"
          },
          on: {
            "click": cancel
          }
        }, [_vm._v("Annuleren")]), _c('b-btn', {
          attrs: {
            "variant": "primary",
            "disabled": _vm.currentPaymentMethodIdentifier === _vm.selectedPaymentMethodIdentifier
          },
          on: {
            "click": ok
          }
        }, [_vm._v("OK")])];
      }
    }])
  }, [_c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_vm._v("Nieuwe methode")]), _vm.editPayment ? _c('b-col', {
    attrs: {
      "cols": "5"
    }
  }, [_vm.allowedPaymentMethods.length > 1 ? _c('span', _vm._l(this.allowedPaymentMethods, function (paymentMethod) {
    return _c('div', {
      key: paymentMethod.identifier
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: _vm.selectedPaymentMethodIdentifier,
        expression: "selectedPaymentMethodIdentifier",
        modifiers: {
          "trim": true
        }
      }],
      staticClass: "mr-2",
      attrs: {
        "name": "paymentMethod",
        "type": "radio",
        "id": paymentMethod.identifier
      },
      domProps: {
        "value": paymentMethod.identifier,
        "checked": _vm._q(_vm.selectedPaymentMethodIdentifier, paymentMethod.identifier)
      },
      on: {
        "change": function ($event) {
          _vm.selectedPaymentMethodIdentifier = paymentMethod.identifier;
        }
      }
    }), _c('label', {
      attrs: {
        "for": paymentMethod.identifier
      }
    }, [_vm._v(_vm._s(paymentMethod.display_name))])]);
  }), 0) : _c('span', [_vm._v(_vm._s(_vm.selectedPaymentMethodName))])]) : _vm._e()], 1)], 1), _c('BRow', {
    staticClass: "mb-4"
  }, [_c('BCol', {
    staticClass: "mb-4",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('OmniCard', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_c('div', {
          staticClass: "d-flex justify-content-between align-items-center"
        }, [_c('BCardTitle', {
          staticClass: "text-uppercase"
        }, [_vm._v(" Informatie ")]), _c('BModal', {
          attrs: {
            "id": "inspect-sales-order-metadata-modal",
            "title": "Extra order data",
            "size": "lg",
            "centered": "",
            "dialog-class": "shadow-none",
            "ok-only": ""
          }
        }, [_c('ShowSalesOrderMetadata', {
          attrs: {
            "salesOrder": _vm.salesOrder
          }
        })], 1)], 1)];
      },
      proxy: true
    }, {
      key: "default",
      fn: function () {
        return [_c('OmniTableSmall', {
          attrs: {
            "fields": _vm.informationFields,
            "items": _vm.informationFieldItems
          },
          scopedSlots: _vm._u([{
            key: "cell(salesOrder_identifier)",
            fn: function (data) {
              return [_vm.useIconForCancelledOrder && _vm.isOrderCancelled({
                salesOrder: _vm.salesOrder
              }) ? _c('FontAwesomeIcon', {
                staticClass: "text-danger mr-1",
                attrs: {
                  "icon": "ban",
                  "title": "Order volledig geannuleerd"
                }
              }) : _vm._e(), _c('span', {
                class: {
                  'text-decoration-line-through': _vm.isOrderCancelled({
                    salesOrder: _vm.salesOrder
                  }) && _vm.strikeThroughCancelledOrder
                }
              }, [_vm._v(_vm._s(data.item['salesOrder_identifier']))])];
            }
          }])
        })];
      },
      proxy: true
    }, {
      key: "footer",
      fn: function () {
        return [_c('OmniButtonCollection', {
          attrs: {
            "direction": "horizontal"
          }
        }, [_vm.canInspectMetadata ? _c('OmniButton', {
          attrs: {
            "icon": "glasses"
          },
          on: {
            "click": function ($event) {
              return _vm.$bvModal.show('inspect-sales-order-metadata-modal');
            }
          }
        }, [_vm._v(" Bekijk meer info ")]) : _vm._e(), _vm.canInspectMetadata ? _c('OmniButton', {
          attrs: {
            "icon": "far fa-file-alt"
          },
          on: {
            "click": function ($event) {
              return _vm.openLink(`/api/rest/sales-orders/${_vm.salesOrder.identifier}/order-create-payload`);
            }
          }
        }, [_vm._v(" Bekijk ruwe data ")]) : _vm._e()], 1)];
      },
      proxy: true
    }])
  })], 1), _c('BCol', {
    staticClass: "mb-4",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('OmniCard', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_c('div', {
          staticClass: "d-flex justify-content-between align-items-center"
        }, [_c('BCardTitle', {
          staticClass: "text-uppercase"
        }, [_vm._v(" Notities ")])], 1)];
      },
      proxy: true
    }, {
      key: "default",
      fn: function () {
        return [_c('OrderCommentsHistory', {
          ref: "orderCommentsHistory",
          staticClass: "limited-height",
          attrs: {
            "salesOrderIdentifier": _vm.salesOrder.identifier
          },
          on: {
            "edit": function (comment) {
              return _vm.openEditCommentModal(comment);
            }
          }
        }), _c('BModal', {
          attrs: {
            "id": "add-comment-form",
            "title": _vm.editComment ? `Notitie wijzigen` : `Nieuwe notitie plaatsen bij order`,
            "size": "xl",
            "dialog-class": "shadow-none",
            "footer-class": "d-none",
            "centered": "",
            "hide-header-close": ""
          }
        }, [_c('OrderCommentsForm', {
          attrs: {
            "salesOrderIdentifier": _vm.salesOrder.identifier,
            "edit-comment": _vm.editComment
          },
          on: {
            "close": function ($event) {
              _vm.editComment = null;
              _vm.$bvModal.hide('add-comment-form');
            },
            "saved": _vm.handleSalesOrderCommentSaved
          }
        })], 1)];
      },
      proxy: true
    }, {
      key: "footer",
      fn: function () {
        return [_vm.hasPermission('orders.addcomment') ? _c('OmniButtonCollection', {
          attrs: {
            "direction": "horizontal"
          }
        }, [_c('OmniButton', {
          staticClass: "mr-1 pt-1",
          attrs: {
            "size": "sm",
            "icon": "circle-plus"
          },
          on: {
            "click": function ($event) {
              return _vm.$bvModal.show('add-comment-form');
            }
          }
        }, [_vm._v(" Notitie toevoegen ")])], 1) : _vm._e()];
      },
      proxy: true
    }])
  })], 1)], 1), _c('BRow', {
    staticClass: "mb-2"
  }, [_c('BCol', {
    staticClass: "mb-4",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('OmniCard', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_c('div', {
          staticClass: "d-flex justify-content-between align-items-center"
        }, [_c('BCardTitle', {
          staticClass: "text-uppercase"
        }, [_vm.salesOrder.fulfilment_method === 'pickup' ? [_vm._v(" " + _vm._s(_vm.$t('omt.gui.orders.label.address-details.order-pickup')) + " ")] : [_vm._v(" " + _vm._s(_vm.$t('omt.gui.orders.label.address-details.order-shipping')) + " ")]], 2), _vm.hasAllPermissions('orders.address.edit', 'orders.edit') ? _c('OmniButton', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: !_vm.editingAddressShipping,
            expression: "!editingAddressShipping"
          }],
          attrs: {
            "icon": "pencil",
            "variant": "info"
          },
          on: {
            "click": function ($event) {
              return _vm.editAddressInformation('shipping');
            }
          }
        }, [_vm._v(" Bewerken ")]) : _vm._e()], 1)];
      },
      proxy: true
    }, {
      key: "default",
      fn: function () {
        return [_c('AddressTable', {
          attrs: {
            "address": _vm.addressShipping,
            "editable": _vm.hasAllPermissions('orders.address.edit', 'orders.edit'),
            "editing": _vm.editingAddressShipping,
            "saving": _vm.savingAddressShipping,
            "orderNo": _vm.salesOrder.identifier
          },
          on: {
            "edit": function ($event) {
              return _vm.editAddressInformation('shipping');
            },
            "save": function ($event) {
              return _vm.saveAddressInformation('shipping', $event);
            },
            "cancel": function ($event) {
              return _vm.cancelEditAddressInformation('shipping');
            }
          }
        })];
      },
      proxy: true
    }])
  })], 1), _c('BCol', {
    staticClass: "mb-4",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('OmniCard', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_c('div', {
          staticClass: "d-flex justify-content-between align-items-center"
        }, [_c('BCardTitle', {
          staticClass: "text-uppercase"
        }, [_vm._v(" " + _vm._s(_vm.$t('omt.gui.orders.label.address-details.order-billing')) + " ")]), _vm.hasAllPermissions('orders.address.edit', 'orders.edit') ? _c('OmniButton', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: !_vm.editingAddressBilling,
            expression: "!editingAddressBilling"
          }],
          attrs: {
            "icon": "pencil",
            "variant": "info"
          },
          on: {
            "click": function ($event) {
              return _vm.editAddressInformation('billing');
            }
          }
        }, [_vm._v(" Bewerken ")]) : _vm._e()], 1)];
      },
      proxy: true
    }, {
      key: "default",
      fn: function () {
        return [_c('AddressTable', {
          attrs: {
            "address": _vm.addressBilling,
            "editable": _vm.hasAllPermissions('orders.address.edit', 'orders.edit'),
            "editing": _vm.editingAddressBilling,
            "saving": _vm.savingAddressBilling,
            "orderNo": _vm.salesOrder.identifier
          },
          on: {
            "save": function ($event) {
              return _vm.saveAddressInformation('billing', $event);
            },
            "cancel": function ($event) {
              return _vm.cancelEditAddressInformation('billing');
            }
          }
        })];
      },
      proxy: true
    }])
  })], 1)], 1), _c('BRow', {
    staticClass: "mb-4"
  }, [_c('BCol', {
    attrs: {
      "cols": "12"
    }
  }, [_c('OmniCard', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_c('BCardTitle', {
          staticClass: "text-uppercase"
        }, [_vm._v(" Leveringen en producten ")]), _vm.showDrqButtonsOnTop ? _c('DrqButtons', {
          staticClass: "mt-4",
          attrs: {
            "salesOrder": _vm.salesOrder,
            "alignment": _vm.drqButtonsAlignment,
            "isDispatchRequestsLoading": _vm.isDispatchRequestsLoading,
            "dispatchRequestRerouteMode": _vm.dispatchRequestRerouteMode,
            "hasReroutableDispatchRequests": _vm.hasReroutableDispatchRequests
          },
          on: {
            "reloadDispatchRequests": _vm.reloadDispatchRequests,
            "toggleRerouteMode": _vm.toggleRerouteMode,
            "openFinalDispatchRequestActionModal": _vm.openFinalDispatchRequestActionModal,
            "showModal": function (modal) {
              return _vm.$bvModal.show(modal);
            }
          }
        }) : _vm._e()];
      },
      proxy: true
    }, {
      key: "default",
      fn: function () {
        var _vm$salesOrder$curren;
        return [_c('BRow', [_c('BCol', {
          attrs: {
            "cols": "12"
          }
        }, [_vm.dispatchRequests ? _c('DispatchRequests', {
          key: _vm.salesOrder.id,
          ref: "dispatchRequestsView",
          class: {
            'opacity-2': _vm.isDispatchRequestsLoading
          },
          attrs: {
            "dispatch-requests": _vm.dispatchRequests,
            "sales-order": _vm.salesOrder,
            "reroute-mode": false
          },
          on: {
            "loaded": function () {
              _vm.hasReroutableDispatchRequests = arguments.length <= 0 ? undefined : arguments[0];
            },
            "dataChanged": _vm.reloadDispatchRequests,
            "reroutingSuccessful": _vm.reloadDispatchRequests
          }
        }) : _vm._e(), _c('b-alert', {
          staticClass: "m-0",
          attrs: {
            "variant": "warning",
            "show": ['on-hold', 'on-hold-final'].includes(_vm.salesOrder.validation_status) && !((_vm$salesOrder$curren = _vm.salesOrder.current_dispatch_requests) !== null && _vm$salesOrder$curren !== void 0 && _vm$salesOrder$curren.length)
          }
        }, [_c('font-awesome-icon', {
          staticClass: "text-danger mr-2",
          attrs: {
            "icon": "triangle-exclamation"
          }
        }), _vm._v(" Deze order heeft geen leveringen omdat deze is geblokkeerd. Ga naar het tabblad "), _c('router-link', {
          attrs: {
            "to": {
              name: 'OrderDetailHoldReasons',
              params: {
                salesOrderIdentifier: _vm.salesOrder.identifier
              }
            }
          }
        }, [_vm._v("blokkeringen")]), _vm._v(" om de blokkering te bekijken. ")], 1)], 1)], 1)];
      },
      proxy: true
    }, {
      key: "footer",
      fn: function () {
        return [_vm.showDrqButtonsOnBottom ? _c('DrqButtons', {
          attrs: {
            "salesOrder": _vm.salesOrder,
            "alignment": _vm.drqButtonsAlignment,
            "isDispatchRequestsLoading": _vm.isDispatchRequestsLoading,
            "dispatchRequestRerouteMode": _vm.dispatchRequestRerouteMode,
            "hasReroutableDispatchRequests": _vm.hasReroutableDispatchRequests
          },
          on: {
            "reloadDispatchRequests": _vm.reloadDispatchRequests,
            "toggleRerouteMode": _vm.toggleRerouteMode,
            "openFinalDispatchRequestActionModal": _vm.openFinalDispatchRequestActionModal,
            "showModal": function (modal) {
              return _vm.$bvModal.show(modal);
            }
          }
        }) : _vm._e(), _c('BModal', {
          attrs: {
            "id": "add-order-line-modal",
            "title": "Orderregel toevoegen",
            "size": "xl",
            "centered": "",
            "dialog-class": "shadow-none",
            "footer-class": "d-none"
          }
        }, [_c('add-sales-order-line', {
          attrs: {
            "sales-order": _vm.salesOrder
          },
          on: {
            "success": function ($event) {
              return _vm.salesOrderLineAdded();
            }
          }
        })], 1), _c('BModal', {
          attrs: {
            "id": "rerouting-modal",
            "title": "Rerouting",
            "size": "xl",
            "centered": "",
            "dialog-class": "shadow-none",
            "footer-class": "d-none"
          },
          on: {
            "hide": _vm.exitRerouteMode
          },
          model: {
            value: _vm.dispatchRequestRerouteMode,
            callback: function ($$v) {
              _vm.dispatchRequestRerouteMode = $$v;
            },
            expression: "dispatchRequestRerouteMode"
          }
        }, [_c('DispatchRequests', {
          attrs: {
            "dispatch-requests": _vm.salesOrder.current_dispatch_requests,
            "sales-order": _vm.salesOrder,
            "reroute-mode": true,
            "hide-actions": true
          },
          on: {
            "dataChanged": _vm.reloadDispatchRequests,
            "cancelRerouteMode": _vm.toggleRerouteMode,
            "reroutingSuccessful": function ($event) {
              return _vm.toggleRerouteMode(false);
            }
          }
        })], 1), _c('BModal', {
          attrs: {
            "id": "inspect-dispatch-request-metadata-modal",
            "okTitle": _vm.$t('omt.gui.general.action.close'),
            "title": `Ruwe data van order nr. ${_vm.salesOrder.identifier}`,
            "size": "lg",
            "centered": "",
            "dialog-class": "shadow-none",
            "ok-only": ""
          },
          scopedSlots: _vm._u([{
            key: "modal-footer",
            fn: function () {
              return [_c('OmniButton', {
                attrs: {
                  "icon": "times"
                },
                on: {
                  "click": function ($event) {
                    return _vm.$bvModal.hide('inspect-dispatch-request-metadata-modal');
                  }
                }
              }, [_vm._v(" Sluiten ")])];
            },
            proxy: true
          }])
        }, [_c('ShowDispatchRequestMetadata', {
          attrs: {
            "salesOrder": _vm.salesOrder
          }
        })], 1), _c('BModal', {
          attrs: {
            "id": "final-dispatch-request-actions-modal",
            "title": _vm.$t(`omt.gui.orders.dispatch-requests.final-action-titles.${_vm.finalDispatchRequestAction}`),
            "size": "lg",
            "centered": "",
            "dialog-class": "shadow-none",
            "hide-footer": ""
          }
        }, [_c('final-dispatch-request-actions', {
          attrs: {
            "sales-order": _vm.salesOrder,
            "action": _vm.finalDispatchRequestAction
          },
          on: {
            "close": function ($event) {
              return _vm.$bvModal.hide('final-dispatch-request-actions-modal');
            },
            "dataChanged": _vm.reloadDispatchRequests
          }
        })], 1)];
      },
      proxy: true
    }])
  })], 1)], 1), _c('BRow', {
    staticClass: "mb-4"
  }, [_c('BCol', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('OmniCard', {
    staticClass: "mb-4",
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_c('BCardTitle', [_vm._v("FACTUUR INFORMATIE")])];
      },
      proxy: true
    }])
  }, [_c('OmniTableSmall', {
    attrs: {
      "fields": _vm.invoice_fields,
      "items": _vm.invoice_items
    }
  })], 1)], 1), _c('BCol', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('OmniCard', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_c('BCardTitle', [_vm._v("BETALINGEN "), _c('span', {
          staticClass: "float-right"
        }, [_vm._v("Toon historie "), _c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: _vm.showAllPayments,
            expression: "showAllPayments"
          }],
          staticClass: "ml-1",
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "checked": Array.isArray(_vm.showAllPayments) ? _vm._i(_vm.showAllPayments, null) > -1 : _vm.showAllPayments
          },
          on: {
            "change": function ($event) {
              var $$a = _vm.showAllPayments,
                $$el = $event.target,
                $$c = $$el.checked ? true : false;
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.showAllPayments = $$a.concat([$$v]));
                } else {
                  $$i > -1 && (_vm.showAllPayments = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
                }
              } else {
                _vm.showAllPayments = $$c;
              }
            }
          }
        })])])];
      },
      proxy: true
    }])
  }, [_vm.isPaymentUpdating ? _c('span', [_c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })], 1) : _c('BTable', {
    attrs: {
      "items": _vm.payments,
      "fields": _vm.paymentsFields,
      "hover": ""
    },
    scopedSlots: _vm._u([{
      key: "cell(datetime)",
      fn: function (data) {
        return [_vm._v(" " + _vm._s(_vm._f("datetime")(data.value)) + " ")];
      }
    }, {
      key: "cell(Methode)",
      fn: function (data) {
        return [_c('span', {
          attrs: {
            "title": `${data.value.payment_service_provider_account.payment_service_provider.name} (${data.value.payment_service_provider_account.identifier})`
          },
          domProps: {
            "textContent": _vm._s(data.value.payment_service_provider_account_method.display_name)
          }
        })];
      }
    }, {
      key: "cell(Bedrag)",
      fn: function (data) {
        return [data.value ? _c('span', [_vm._v(_vm._s(_vm._f("price")(data.value)))]) : _c('i', [_vm._v("onbekend")])];
      }
    }, {
      key: "cell(actions)",
      fn: function (data) {
        return [_c('span', {
          staticClass: "ml-1"
        }, [_vm.isPaymentEditable(data.item) ? _c('b-btn', {
          staticClass: "py-0",
          attrs: {
            "variant": "link",
            "size": "sm"
          },
          on: {
            "click": function ($event) {
              return _vm.openEditPaymentModal(data.item);
            }
          }
        }, [_vm._v("wijzigen")]) : _vm._e()], 1)];
      }
    }])
  })], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }